import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <CommentsSection />
        <TopicsSection />
        <CarouselSection />
        <RankingSection />
        <ContactSection />
        <CardsSection />
        <IndexSection />
        <FAQSection />
        <UpdatesSection />
        <MediaSection />
        <FeaturesSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}